function getFromStorage(image) {
  return process.env.VUE_APP_STORAGE_URL + image;
}

export { getFromStorage }
